<script>
export default {
    name: 'IconFold',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-fold"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M56 44L32.004 20l-.003.005-.005-.005L8 44z"
            fill-rule="evenodd"
        />
    </svg>
</template>
